import { j as g, s as v, v as p, L as l, d as u, f as E, k as c } from "./export-cdcbfb2b.js";
import { t as O } from "./to-string-92a62764.js";
import { b as R } from "./es.string.replace-f4cc3aea.js";
var x = g, N = v, P = p, m = R, e = RegExp.prototype, y = function(a) {
  var r = a.flags;
  return r === void 0 && !("flags" in e) && !N(a, "flags") && P(e, a) ? x(m, a) : r;
}, I = l.PROPER, b = u, S = c, n = O, T = E, _ = y, t = "toString", o = RegExp.prototype, s = o[t], d = T(function() {
  return s.call({ source: "a", flags: "b" }) !== "/a/b";
}), C = I && s.name !== t;
(d || C) && b(o, t, function() {
  var r = S(this), i = n(r.source), f = n(_(r));
  return "/" + i + "/" + f;
}, { unsafe: !0 });
export {
  y as r
};
